import React from 'react';
import { Link } from 'react-router-dom';
import { StethoscopeIcon, BrainIcon, HeartIcon, UsersIcon, ShieldCheckIcon, GraduationCapIcon, ArrowRightIcon } from 'lucide-react';
export function ServicesPage() {
  return <div className="pt-20" data-id="element-377">
      <section className="bg-brand-navy py-24 text-white" data-id="element-378">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-379">
          <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-380">Our Services</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-381">
            Integrating primary healthcare, lifestyle wellness, and mental
            health coaching.
          </p>
        </div>
      </section>

      <section className="py-24 bg-white" data-id="element-382">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-383">
          <div className="grid lg:grid-cols-2 gap-12 mb-20" data-id="element-384">
            <div className="bg-brand-light p-10 rounded-3xl border border-gray-100" data-id="element-385">
              <div className="bg-white w-16 h-16 rounded-2xl flex items-center justify-center shadow-sm mb-6" data-id="element-386">
                <StethoscopeIcon className="h-8 w-8 text-brand-red" data-id="element-387" />
              </div>
              <h2 className="text-3xl font-bold text-brand-navy mb-6" data-id="element-388">
                Family Practice & Wellness
              </h2>
              <ul className="space-y-4" data-id="element-389">
                {['Preventive care and wellness exams', 'Chronic disease management', 'Lifestyle counseling and wellness planning', 'Health Risk Assessments (HRAs)', 'Comprehensive health evaluations', 'Critical Care Consultation'].map(item => <li key={item} className="flex items-start text-gray-700" data-id="element-390">
                    <ShieldCheckIcon className="h-5 w-5 text-brand-red mr-3 mt-1 flex-shrink-0" data-id="element-391" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="bg-brand-navy p-10 rounded-3xl text-white" data-id="element-392">
              <div className="bg-white/10 w-16 h-16 rounded-2xl flex items-center justify-center mb-6" data-id="element-393">
                <BrainIcon className="h-8 w-8 text-brand-red" data-id="element-394" />
              </div>
              <h2 className="text-3xl font-bold mb-6" data-id="element-395">
                Mental Health Coaching
              </h2>
              <ul className="space-y-4" data-id="element-396">
                {['Marriage and Relationship Restoration', 'Grief and Loss Support', 'Trauma and PTSD Support', 'Anxiety and Depression Support', 'Youth and Adolescent Coaching', 'Geriatric Mental Wellness', 'Life Recovery and Purpose Coaching'].map(item => <li key={item} className="flex items-start text-gray-300" data-id="element-397">
                    <HeartIcon className="h-5 w-5 text-brand-red mr-3 mt-1 flex-shrink-0" data-id="element-398" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="bg-brand-red rounded-3xl p-10 text-white" data-id="element-399">
            <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-400">
              <div className="bg-white/20 p-6 rounded-2xl" data-id="element-401">
                <GraduationCapIcon className="h-12 w-12" data-id="element-402" />
              </div>
              <div data-id="element-403">
                <h3 className="text-2xl font-bold mb-2" data-id="element-404">
                  Consultation & Professional Training
                </h3>
                <p className="text-white/90 text-lg" data-id="element-405">
                  We offer healthcare consultation, mental wellness workshops,
                  and organizational wellness programs for employers and
                  government agencies.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-brand-navy text-white" data-id="element-406">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-407">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-408">
            Not sure which service is right for you?
          </h2>
          <p className="text-lg text-gray-300 mb-10" data-id="element-409">
            Schedule a brief consultation with our team to discuss your needs
            and find the best path forward.
          </p>
          <Link to="/contact" className="inline-flex items-center bg-brand-red text-white px-10 py-4 rounded-xl font-bold text-lg hover:bg-white hover:text-brand-navy transition-all shadow-xl group" data-id="element-410">
            Book a Consultation
            <ArrowRightIcon className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-411" />
          </Link>
        </div>
      </section>
    </div>;
}